import { XamarinIcon } from './XamarinIcon';

/**
 * author: Contributors
 * id 958B8A8B-A4D7-45A4-8C80-39F7140443C0
 * name xamarin
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/xamarin.svg
 * tags
 * - Brand / Logo 
 */
export const MicrosoftXamarinIcon = XamarinIcon;
export default MicrosoftXamarinIcon